export class ReturnToQueueRequest {
    public idReturnToQueue: number;

    public idQueue: number;

    public idEpisode: number;

    public datetimeInclusion: Date;
}